import { gql } from "lib/apolloClient";
import {
  attachmentFragment,
  studentsAlertFragment,
} from "modules/CommonFragments";

export const incidentFragment = {
  incidentDetailsFragment: gql`
    fragment incidentDetails on BehaviourIncident {
      id
      uid
      title
      category {
        id
        name
        color
        level
        rootCategory {
          id
          name
          iconData
          color
          sentiment {
            id
            label
          }
          curriculumPrograms {
            id
          }
        }
      }
      severity {
        id
        level
        name
        color
      }
      involvedStudent {
        id
        firstName
        lastName
        profileImage
        middleName
        preferredName
        pronouns
        prefix
        suffix
        gender
        alertTypes {
          ...alertTypeFields
        }
        yearGroup {
          id
          curriculumProgram {
            id
          }
          grade {
            id
            name
          }
        }
      }
      location {
        id
        name
      }
      incidentTime
      accessibilityMap {
        id
        type
        entityId
        shouldNotify
        roleAccessType
        users {
          ... on Staff {
            prefix
            pronouns
            preferredName
            suffix
            role
            rnpRoleContextDetail(filters: { roleModule: ["BEHAVIOUR"] }) {
              id
              role {
                id
                label
              }
              contextType
              context {
                id
              }
            }
          }
          ... on FamilyMember {
            prefix
            pronouns
            preferredName
            suffix
          }
          ... on Student {
            prefix
            pronouns
            preferredName
            suffix
            alertTypes {
              ...alertTypeFields
            }
          }
          id
          firstName
          lastName
          middleName
          type
          profileImage
        }
        details {
          id
          type
          value
        }
        createdAt
        createdBy {
          id
          firstName
          middleName
          lastName
          ... on Staff {
            prefix
            suffix
            preferredName
            pronouns
          }
        }
        updatedAt
        updatedBy {
          id
          firstName
          middleName
          lastName
          ... on Staff {
            prefix
            suffix
            preferredName
            pronouns
          }
        }
      }
      appliedActions {
        id
        status
        fields {
          id
          uid
          value
        }
        appliedAt
        appliedBy {
          id
          firstName
          middleName
          lastName
          ... on Staff {
            prefix
            suffix
            preferredName
            pronouns
          }
        }
        action {
          id
          title
          type
          state
          metadata
        }
      }
      linkedIncidents {
        id
        uid
        title
        userAccessibilityDetails {
          id
          type
          value
        }
        involvedStudent {
          id
          firstName
          middleName
          lastName
          preferredName
          pronouns
          prefix
          suffix
          profileImage
        }
        category {
          id
          name
          color
          level
          rootCategory {
            id
            name
            iconData
            color
          }
        }
        createdBy {
          id
          firstName
          lastName
          middleName
          profileImage
          ... on Staff {
            prefix
            suffix
            preferredName
            pronouns
          }
        }
        description
        severity {
          id
          name
          level
          color
        }
      }
      description
      confidentialNote
      attachments {
        ...attachmentItem
      }
      confidentialAttachments {
        ...attachmentItem
      }
      state
      createdBy {
        id
        firstName
        lastName
        profileImage
        middleName
        ... on Staff {
          prefix
          suffix
          preferredName
          pronouns
        }
      }
      createdAt
      updatedAt
      updatedBy {
        id
        firstName
        middleName
        lastName
        ... on Staff {
          prefix
          suffix
          preferredName
          pronouns
        }
      }
      userAccessibilityDetails {
        id
        type
        value
      }
    }
    ${studentsAlertFragment}
    ${attachmentFragment.attachment}
  `,
};

export const studentFragment = {
  studentFamiliesFragment: gql`
    fragment studentFamilies on Student {
      id
      families(filters: $familiesFilter) {
        id
        familyMember {
          id
          type
          firstName
          lastName
          middleName
          profileImage
          preferredName
          prefix
          suffix
          pronouns
        }
      }
    }
  `,
  studentHomeroomAdvisorFragment: gql`
    fragment studentHomeroomAdvisor on Student {
      id
      staffRelation(filters: $staffRelationFilters) {
        edges {
          node {
            ... on Staff {
              role
              prefix
              preferredName
              pronouns
              suffix
            }
            id
            firstName
            lastName
            middleName
            type
            profileImage
          }
        }
      }
    }
  `,
};
